import React from 'react';
import { Menu } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from 'shadcn/components/ui/DropdownMenu';

/**
 * @param {Object} props
 * @param {string} [props.facilityName]
 * @param {boolean} [props.isEnabled=true]
 * @param {() => void} [props.onToggleEnabled]
 */
export function SubstitutionRuleActionsMenu({ facilityName, isEnabled = true, onToggleEnabled = () => {} }) {
    const facilityLabel = facilityName ? ` (${facilityName})` : '';

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button type="button" variant="ghost" size="icon" aria-label="Open actions menu">
                    <Menu className="h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem onSelect={onToggleEnabled}>
                    {isEnabled ? 'Disable' : 'Enable'} Rule for Facility{facilityLabel}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

SubstitutionRuleActionsMenu.displayName = 'SubstitutionRuleActionsMenu';
